import { getHostname } from './getHostname';

const DESIGN_SYSTEM_SERVER_URLS = {
  production: 'https://design-system-bff.zapier.com',
  staging: 'https://design-system-bff.zapier-staging.com',
  localhost: 'http://localhost:8000',
};

export const getServerUrl = (bffHostname: string): string => {
  const hostname = getHostname();

  if (hostname.endsWith('zapier.com')) {
    return DESIGN_SYSTEM_SERVER_URLS.production;
  } else if (hostname.endsWith('zapier-staging.com')) {
    if (bffHostname) {
      return bffHostname;
    }
    return DESIGN_SYSTEM_SERVER_URLS.staging;
  } else if (hostname === 'localhost') {
    /**
     * Localhost should using staging server as well.
     * Use the bffHostname prop if you would like to use a local server
     */
    if (bffHostname) {
      return bffHostname;
    }
    return DESIGN_SYSTEM_SERVER_URLS.staging;
  }

  return DESIGN_SYSTEM_SERVER_URLS.staging;
};
